import { render, staticRenderFns } from "./EvDrawer.vue?vue&type=template&id=67487edf&scoped=true&lang=pug"
import script from "./EvDrawer.vue?vue&type=script&lang=js"
export * from "./EvDrawer.vue?vue&type=script&lang=js"
import style0 from "./EvDrawer.vue?vue&type=style&index=0&id=67487edf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67487edf",
  null
  
)

export default component.exports